import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";

import { NavigationService } from "../services/navigation.service";

/**
 * MasqueradeGuardService - Validates masquerade route access
 *
 * Ensures that /masquerade route has a valid token query parameter
 * before allowing access.
 */
@Injectable({
  providedIn: "root",
})
export class MasqueradeGuardService  {
  constructor(private readonly nav: NavigationService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const token = route.queryParams["token"];

    if (!token) {
      // No token provided - redirect to error page
      this.nav.navigateTo(["/session/error"], {
        queryParams: {
          message: "Invalid masquerade link - no token provided",
        },
      });
      return false;
    }

    return true;
  }
}
